import { useState, useEffect, useContext } from 'react';
import { AuthContext } from '../context/AuthContext';
import UserRecommendationAccessService from '../Services/UserRecommendationAccessService';

/**
 * Custom hook to fetch user's accessible recommendations
 * Similar to how rs-admin's UserRecommendationViewer works
 * 
 * @returns {{recommendations: Array, loading: boolean, error: string|null}}
 */
export const useUserRecommendationAccess = () => {
  const { user } = useContext(AuthContext);
  const [recommendations, setRecommendations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRecommendations = async () => {
      if (!user || !user.uid) {
        setRecommendations([]);
        setError('User not authenticated');
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        console.log('🔍 useUserRecommendationAccess: Fetching recommendations for user:', user.uid);
        const data = await UserRecommendationAccessService.getUserAccessibleRecommendations(user.uid);
        console.log('✅ useUserRecommendationAccess: Fetched recommendations:', data);
        setRecommendations(data);
      } catch (err) {
        console.error('❌ useUserRecommendationAccess: Error fetching recommendations:', err);
        setError(err.message || 'Failed to fetch recommendations');
      } finally {
        setLoading(false);
      }
    };

    fetchRecommendations();
  }, [user]);

  return { recommendations, loading, error };
};

